import { MetaType, AssetRef } from "../types"
import {
  actionCreatorGuard,
  reducerGuard,
  processActionMeta,
  getArrayReducerGuard
} from "../reducers"

const kind = "block_pdfs"

export type BlockPdf = {
  kind: typeof kind
  version: number
  type: "pdf"
  assets: Array<AssetRef>
  meta: MetaType
}

export const reducerAction = {
  meta: actionCreatorGuard<BlockPdf, MetaType>("meta", kind),
  assets: actionCreatorGuard<BlockPdf, Array<AssetRef>>("assets", kind),
  type: actionCreatorGuard<BlockPdf, string>("type", kind)
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<
    BlockPdf,
    "kind" | "version"
  >]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const blockPdfAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const blockPdfReducer = reducerGuard<BlockPdf>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.assets)
  .default((prevState, action: any) => {
    action = processActionMeta(action)

    switch (action?.meta?.prop) {
      case "assets":
        return getArrayReducerGuard<BlockPdf, AssetRef>(
          kind,
          "assets",
          "AssetRef",
          prevState,
          action
        )
    }

    return prevState
  })
